/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../config.js";
import { loadModules } from 'esri-loader';

const state = {
  mapWebScene: null,
  mapView: null,
  initialHazards: [],
  hazardComments: [],
  currentHazardId: null,
  currentHazard: null,
  currentComments: [],
  userName: null,
  user: null,
  commentAttachments: [],
  staticHazardLayerId: "hazard-graphics",
  staticHazardLayerTitle: "User Hazards",
  mapWebSceneLoadFlag: null,
  isAddNewHazard: false,
  userList: [],
  filterLayer: {
    user: "",
    severity: "Major",
    hazardType: ""
  }
}

function initialState() {
  return {
    mapWebScene: null,
    mapView: null,
    initialHazards: [],
    hazardComments: [],
    currentHazardId: null,
    currentHazard: null,
    currentComments: [],
    userName: null,
    user: null,
    commentAttachments: [],
    staticHazardLayerId: "hazard-graphics",
    staticHazardLayerTitle: "User Hazards",
    mapWebSceneLoadFlag: null,
    isAddNewHazard: false,
    userList: [],
    filterLayer: {
      user: "",
      severity: "Major",
      hazardType: ""
    }
  }
}
const mutations = {
  saveMapWebScene(state, data) {
    state.mapWebScene = data
  },
  saveMapView(state, data) {
    state.mapView = data
  },
  saveUserName(state, data) {
    state.userName = data
  },
  saveUser(state, data) {
    state.user = data
  },
  insertUserList(state, data){
    state.userList = data
  },
  insertInitialHazards(state, payload) {
    console.log("insertInitialHazards");
    console.log(payload);
    state.initialHazards.push(payload)
  },
  setInitialHazards(state, data) {
    state.initialHazards = data
  },
  resetInitialHazards(state) {
    state.initialHazards = []
  },
  setFilterLayer(state, data) {
    state.filterLayer = data
  },
  resetHazardComments(state) {
    state.hazardComments = []
  },
  insertHazardComments(state, payload) {
    state.hazardComments.push(payload)
  },
  setCurrentHazardId(state, payload) {
    state.currentHazardId = payload
  },
  setCurrentHazard(state, payload) {
    state.currentHazard = payload
  },
  setCurrentComments(state, payload) {
    payload.comments.forEach(item=>{
      state.currentComments.push(item)
    })
  },
  clearCurrentComments(state) {
    state.currentComments = []
  },
  addNewComment(state, payload) {
    var objectId = payload.objectId
    var currentComments = state.hazardComments.filter(obj=>obj.objectId == objectId)
    if (currentComments.length) {
      currentComments[0].comments.push(payload.comment)
    }
    else {
      var hazardComment = {
        decision: payload.decision,
        approvalStateCode: payload.approvalStateCode,
        objectId: objectId,
        comments: [payload.comment]
      }
      console.log(hazardComment);
      state.hazardComments.push(hazardComment)
    }
  },
  finalizeHazard(state, payload) {
    var currentHazard = state.initialHazards.filter(obj=>obj.objectId == payload.objectId)
    currentHazard[0].approvalStatus = payload.decision?"Approved":currentHazard.approvalStatus
    console.log(currentHazard);
  },
  clearAttachments(state) {
    state.commentAttachments = []
  },
  addAttachment(state, payload) {
    state.commentAttachments.push(payload)
  },
  removeAttachment(state, index) {
    state.commentAttachments.splice(index,1)
  },
  setMapWebSceneLoadFlag(state, payload) {
    state.mapWebSceneLoadFlag = payload
  },
  setIfAddNewHazardClicked(state, payload){
    state.isAddNewHazard = payload
  },
}

const actions = {
  async fetchHazardComments ({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      let url = baseApiUrl + "fetchComments"
      let data    = {
        hazardIds: payload.objectIds
      }
      let config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        commit("resetHazardComments")
        result.data.forEach((item,index) => {
          commit('insertHazardComments', item);
        })
        resolve();
      }).catch(error=>{
        reject(error);
      })
    })
  },
  setCurrentHazardDetails({state, commit}, payload) {
    commit("setCurrentHazardId", payload)
    var currentHazard = state.initialHazards.filter(obj=>obj.objectId == payload)
    console.log(currentHazard);
    if (currentHazard.length) {
      commit("setCurrentHazard", currentHazard)
    }
    var currentComments = state.hazardComments.filter(obj=>obj.objectId == payload)
    commit("clearCurrentComments")
    if (currentComments.length) {
      commit("setCurrentComments", currentComments[0])
    }
    console.log("Current Hazard: ");
    console.log(state.currentHazard);
    console.log("Current Comments: ");
    console.log(state.currentComments);
  },
  fetchHazardLayer({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      // const vue = document.getElementById("map").__vue__
      // const view = vue.view
      var url = baseApiUrl + "fetchHazards"
      var data = {filterLayer: payload}
      var config = {
        responseType: 'json'
      }
      axios.post(url, data, config).then(response=>{
        if(response){
          var hazardsList = response.data.features
          console.log(hazardsList);
          var hazardsCount = 0;
          loadModules([
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/PopupTemplate"
          ],{ css: true })
          .then(([
            GraphicsLayer,
            Graphic,
            PopupTemplate
          ]) => {
            const hazardGraphicsLayer = new GraphicsLayer({
              id: state.staticHazardLayerId,
              title: state.staticHazardLayerTitle
            });
            const popupTemplate = new PopupTemplate({
              title: "Hazard Details",
              content: [{
                type: "fields",
                fieldInfos: [
                  {
                    fieldName: "id",
                    label: "Object ID"
                  },
                  {
                    fieldName: "hazardCreatedBy",
                    label: "Created by"
                  },
                  {
                    fieldName: "requestDetails",
                    label: "Request"
                  },
                  {
                    fieldName: "hazardType",
                    label: "Type"
                  },
                  {
                    fieldName: "requestCreated",
                    label: "Request Created"
                  },
                  {
                    fieldName: "date",
                    label: "Date"
                  },
                  {
                    fieldName: "approvalState",
                    label: "Approval Status"
                  },
                  {
                    fieldName: "priority",
                    label: "Priority"
                  }
                ]
              }]
            });
            // for (const hazard of hazardsList) {
            // var hazardPoints = hazardsList[0].hazardPoints;
            hazardsList.forEach(hazard=>{
              // if(hazard.attributes.userName == state.filterLayer.user || hazard.attributes.severity == state.filterLayer.severity || hazard.attributes.hazardType == state.filterLayer.hazardType){
              // console.log(hazard);
              // console.log(state.filterLayer);
              // if(hazard.attributes.severity == state.filterLayer.severity){

                hazard.hazardPoints.forEach(hazardPoint=>{

                  var hazardEntry = new Graphic({
                    geometry: {
                      type: "point",
                      latitude: hazardPoint.geometry.latitude,
                      longitude:hazardPoint.geometry.longitude,
                      z: hazardPoint.geometry.height
                    },
                    attributes: hazard.attributes,
                    symbol: {
                      type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                      // url: "DefaultMarker.png",
                      url: hazard.attributes.severity+".png",
                      width: 20
                      // type: "point-3d",
                      // symbolLayers: [{
                      //   type: "object",
                      //   anchor: "origin",
                      //   width: 5,
                      //   material: {
                      //     color: [198, 235, 52, 1]
                      //   }
                      // }]
                    },
                    popupTemplate: popupTemplate
                  });

                  hazardGraphicsLayer.graphics.push(hazardEntry)

                })
              // }
            })
            resolve(hazardGraphicsLayer)
          })
        }
      })
    });
  }
}

const getters = {}



export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
